import React, { PureComponent } from 'react';

export default class DocComment extends PureComponent {
    handleTextClick = () => {
        this.activateBlock();
    }

    activateBlock() {
        this.props.onActivate && this.props.onActivate(this.threadId);
    }

    get threadId() {
        return this.props.threadId;
    }

    render() {
        const { attributes, children, blockHovered, hasNotifications } = this.props;
        const threadId = this.threadId;

        return (
            <span
                {...attributes}
                ref={el => this.el = el}
                className={'commented-text' + (blockHovered ? ' active' : '') + (hasNotifications ? ' has-notifications' : '')}
                id={`thread-${threadId}`}
                onClick={this.handleTextClick}
            >{children}</span>
        )
    }
}
